export const deLocale = {
    'AttributionControl.ToggleAttribution': 'Quellennachweis umschalten',
    'AttributionControl.MapFeedback': 'Karten-Feedback',
    'FullscreenControl.Enter': 'Vollbildmodus aktivieren',
    'FullscreenControl.Exit': 'Vollbildmodus beenden',
    'GeolocateControl.FindMyLocation': 'Meinen Standort finden',
    'GeolocateControl.LocationNotAvailable': 'Standort nicht verfügbar',
    'LogoControl.Title': 'MapLibre-Logo',
    'Map.Title': 'Karte',
    'Marker.Title': 'Kartenmarkierung',
    'NavigationControl.ResetBearing': 'Ziehen zum Drehen, Klicken zum Einnorden',
    'NavigationControl.ZoomIn': 'Vergrößern',
    'NavigationControl.ZoomOut': 'Verkleinern',
    'Popup.Close': 'Popup schließen',
    'ScaleControl.Feet': 'ft',
    'ScaleControl.Meters': 'm',
    'ScaleControl.Kilometers': 'km',
    'ScaleControl.Miles': 'mi',
    'ScaleControl.NauticalMiles': 'sm',
    'GlobeControl.Enable': 'Globus aktivieren',
    'GlobeControl.Disable': 'Globus deaktivieren',
    'TerrainControl.Enable': 'Gelände aktivieren',
    'TerrainControl.Disable': 'Gelände deaktivieren',
    'CooperativeGesturesHandler.WindowsHelpText': 'Verwenden Sie Strg + Scrollen, um die Karte zu zoomen',
    'CooperativeGesturesHandler.MacHelpText': 'Verwenden Sie ⌘ + Scrollen, um die Karte zu zoomen',
    'CooperativeGesturesHandler.MobileHelpText': 'Verwenden Sie zwei Finger, um die Karte zu bewegen',
};
